import { EFuncao, EParametro, ESistema, EVariavel } from "../styles";
import { NivelAlgoritmoEnum } from "../../../../../../enums";

export function expressaoCalculos(
  nivel: number,
  expressao: string[],
  listaVariaveis: number[]
) {
  switch (nivel) {
    case NivelAlgoritmoEnum.FACIL:
      return (
        <>
          <p>
            <ESistema>funcao</ESistema> <EFuncao>calcular</EFuncao>(
            <EParametro>valor</EParametro>)
          </p>
          <p>{"{"}</p>
          <p className="indenta">
            <ESistema>retorne</ESistema> <EVariavel>{expressao[0]}</EVariavel>;
          </p>
          <p>{"}"}</p>
          <br />
          <p>
            <EVariavel>resultado</EVariavel> = <EFuncao>calcular</EFuncao>(
            <EParametro>{listaVariaveis[2]}</EParametro>
            );
          </p>
        </>
      );
    case NivelAlgoritmoEnum.MEDIO:
      return (
        <>
          <p>
            <ESistema>funcao</ESistema> <EFuncao>calcular</EFuncao>(
            <EParametro>valor</EParametro>)
          </p>
          <p>{"{"}</p>
          <p className="indenta">
            <ESistema>retorne</ESistema> <EVariavel>{expressao[0]}</EVariavel>;
          </p>
          <p>{"}"}</p>
          <br />
          <p>
            <EVariavel>resultado</EVariavel> = <EFuncao>calcular</EFuncao>(
            <EParametro>{listaVariaveis[3]}</EParametro>
            );
          </p>
        </>
      );
    default:
      return (
        <>
          <p>
            <ESistema>funcao</ESistema> <EFuncao>calcular</EFuncao>(
            <EParametro>valor</EParametro>)
          </p>
          <p>{"{"}</p>
          <p className="indenta">
            <ESistema>retorne</ESistema> <EVariavel>{expressao[0]}</EVariavel>;
          </p>
          <p>{"}"}</p>
          <br />
          <p>
            <EVariavel>resultado</EVariavel> = <EFuncao>calcular</EFuncao>(
            <EParametro>{listaVariaveis[4]}</EParametro>
            );
          </p>
        </>
      );
  }
}

export function expressaoCondicionais(
  nivel: number,
  expressao: string[],
  listaVariaveis: number[]
) {
  switch (nivel) {
    case NivelAlgoritmoEnum.FACIL:
      return (
        <>
          <p>
            <ESistema>funcao</ESistema> <EFuncao>calcular</EFuncao>(
            <EParametro>valor</EParametro>)
          </p>

          <p>{"{"}</p>
          <p className="indenta">
            SE {"("}
            <EVariavel>{expressao[0]}</EVariavel>
            {")"}
          </p>
          <p className="indenta">{"{"}</p>
          <p className="indenta2">
            <ESistema>retorne</ESistema> <EVariavel>{expressao[1]}</EVariavel>;
          </p>
          <p className="indenta">{"}"}</p>

          <p className="indenta">SENÃO {"{"}</p>
          <p className="indenta2">
            <ESistema>retorne</ESistema> <EVariavel>{expressao[2]}</EVariavel>;
          </p>
          <p className="indenta">{"}"}</p>

          <p>{"}"}</p>
          <br />

          <p>
            <EVariavel>resultado</EVariavel> = <EFuncao>calcular</EFuncao>(
            <EParametro>{listaVariaveis[2]}</EParametro>
            );
          </p>
        </>
      );
    case NivelAlgoritmoEnum.MEDIO:
      return (
        <>
          <p>
            <ESistema>funcao</ESistema> <EFuncao>calcular</EFuncao>(
            <EParametro>valor</EParametro>)
          </p>

          <p>{"{"}</p>
          <p className="indenta">
            SE {"("}
            <EVariavel>{expressao[0]}</EVariavel>
            {")"}
          </p>
          <p className="indenta">{"{"}</p>
          <p className="indenta2">
            <ESistema>retorne</ESistema> <EVariavel>{expressao[1]}</EVariavel>;
          </p>
          <p className="indenta">{"}"}</p>

          <p className="indenta">SENÃO {"{"}</p>
          <p className="indenta2">
            <ESistema>retorne</ESistema> <EVariavel>{expressao[2]}</EVariavel>;
          </p>
          <p className="indenta">{"}"}</p>

          <p>{"}"}</p>
          <br />

          <p>
            <EVariavel>resultado</EVariavel> = <EFuncao>calcular</EFuncao>(
            <EParametro>{listaVariaveis[3]}</EParametro>
            );
          </p>
        </>
      );
    default:
      return (
        <>
          <p>
            <ESistema>funcao</ESistema> <EFuncao>calcular</EFuncao>(
            <EParametro>valor</EParametro>)
          </p>
          <p>{"{"}</p>
          <p className="indenta">
            ENQUANTO {"("}
            <EVariavel>numeroN {"<"} valor</EVariavel>
            {")"}
          </p>
          <p className="indenta">{"{"}</p>
          <p className="indenta2">
            <EVariavel>numeroN </EVariavel> ={" "}
            <EVariavel>numeroN + {expressao[1]}</EVariavel>;
          </p>
          <p className="indenta">{"}"}</p>
          <p className="indenta">FIM ENQUANTO</p>
          <p>{"}"}</p>
          <br />
          <p>
            <ESistema>execute</ESistema> <EFuncao>calcular</EFuncao>(
            <EParametro>{listaVariaveis[3]}</EParametro>
            );
          </p>
        </>
      );
  }
}

export function expressaoRepeticoes(
  nivel: number,
  expressao: string[],
  listaVariaveis: number[]
) {
  switch (nivel) {
    case NivelAlgoritmoEnum.FACIL:
      return (
        <>
          <p>
            <ESistema>funcao</ESistema> <EFuncao>calcular</EFuncao>(
            <EParametro>valor</EParametro>)
          </p>
          <p>{"{"}</p>
          <p className="indenta">
            ENQUANTO {"("}
            <EVariavel>numeroN {"<"} valor</EVariavel>
            {")"}
          </p>
          <p className="indenta">{"{"}</p>
          <p className="indenta2">
            <EVariavel>numeroN </EVariavel> ={" "}
            <EVariavel>numeroN + {expressao[1]}</EVariavel>;
          </p>
          <p className="indenta">{"}"}</p>
          <p className="indenta">FIM ENQUANTO</p>
          <p>{"}"}</p>
          <br />
          <p>
            <ESistema>execute</ESistema> <EFuncao>calcular</EFuncao>(
            <EParametro>{listaVariaveis[2]}</EParametro>
            );
          </p>
        </>
      );
    case NivelAlgoritmoEnum.MEDIO:
      return (
        <>
          <p>
            <ESistema>funcao</ESistema> <EFuncao>calcular</EFuncao>(
            <EParametro>valor</EParametro>)
          </p>
          <p>{"{"}</p>
          <p className="indenta">
            ENQUANTO {"("}
            <EVariavel>numeroN {"<"} valor</EVariavel>
            {")"}
          </p>
          <p className="indenta">{"{"}</p>
          <p className="indenta2">
            <EVariavel>numeroN </EVariavel> ={" "}
            <EVariavel>numeroN + {expressao[1]}</EVariavel>;
          </p>
          <p className="indenta">{"}"}</p>
          <p className="indenta">FIM ENQUANTO</p>
          <p>{"}"}</p>
          <br />
          <p>
            <ESistema>execute</ESistema> <EFuncao>calcular</EFuncao>(
            <EParametro>{listaVariaveis[3]}</EParametro>
            );
          </p>
        </>
      );
    default:
      return (
        <>
          <p>
            <ESistema>funcao</ESistema> <EFuncao>calcular</EFuncao>(
            <EParametro>valor</EParametro>)
          </p>
          <p>{"{"}</p>
          <p className="indenta">
            ENQUANTO {"("}
            <EVariavel>numeroN {"<"} valor</EVariavel>
            {")"}
          </p>
          <p className="indenta">{"{"}</p>
          <p className="indenta2">
            <EVariavel>numeroN </EVariavel> ={" "}
            <EVariavel>numeroN + {expressao[1]}</EVariavel>;
          </p>
          <p className="indenta">{"}"}</p>
          <p className="indenta">FIM ENQUANTO</p>
          <p>{"}"}</p>
          <br />
          <p>
            <ESistema>execute</ESistema> <EFuncao>calcular</EFuncao>(
            <EParametro>{listaVariaveis[3]}</EParametro>
            );
          </p>
        </>
      );
  }
}
